import React from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { useAvailableMakes } from './useVehiclesTable'
import { upperFirst } from 'lodash'

interface VehicleMakeSelectFieldProps {
  onChange: (selectedValue: string) => void
  value: string
}

export default function VehicleMakeSelectField({
  onChange,
  value,
}: VehicleMakeSelectFieldProps) {
  const availableMakes = useAvailableMakes()

  return (
    <FormControl sx={{marginLeft: '16px',}}>
      <InputLabel htmlFor="make-select">Make</InputLabel>
      <Select
        id="make-select"
        label="Make"
        onChange={(ev) => onChange(ev.target.value)}
        value={value}
      >
        {availableMakes.map((make) => (
          <MenuItem key={make} value={make}>
            {upperFirst(make)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
